import { LoginResponseInterface } from '../../models/login-response.interface';

export interface LoginState {
  customerToken: LoginResponseInterface|{customerId: string};
}

export const initialLoginState: LoginState = {
  customerToken: null
};
